const consoleProxy = new Proxy(console, {
  get(target, prop) {
    if (process.env.NODE_ENV !== "production") {
      // @ts-expect-error it's fine
      return target[prop].bind(target);
    }
    return () => {};
  },
});

export default consoleProxy;
